import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    root: {
        backgroundColor: COLOR.BLACK,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
});

export default styles;
